import { useEffect, useState } from "react"
import { useLocation } from "react-router"
import { appQueryParams } from "../../routes"

/**
 * Interface representing the query parameters.
 *
 * @interface QueryParams
 * @property {string | null} locationIdQueryParam - The practice location ID obtained from the query parameters.
 * @property {string | null} practiceIdQueryParam - The practice ID obtained from the query parameters.
 * @property {string | null} providerIdQueryParam - The provider ID obtained from the query parameters.
 */
interface QueryParams {
  locationIdQueryParam: string | null
  practiceIdQueryParam: string | null
  providerIdQueryParam: string | null
}

/**
 * Custom hook for extracting query parameters.
 *
 * @returns {QueryParams} An object containing the extracted query parameters.
 */
export const useQueryParams = (): QueryParams => {
  const location = useLocation()
  const [queryParams, setQueryParams] = useState<QueryParams>({
    locationIdQueryParam: null,
    practiceIdQueryParam: null,
    providerIdQueryParam: null,
  })

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const locationIdQueryParam = searchParams.get(appQueryParams.LOCATION_ID)
    const practiceIdQueryParam = searchParams.get(appQueryParams.PRACTICE_ID)
    const providerIdQueryParam = searchParams.get(appQueryParams.PROVIDER_ID)
    setQueryParams({
      locationIdQueryParam,
      practiceIdQueryParam,
      providerIdQueryParam,
    })
  }, [location.search, location.pathname])

  return queryParams
}
